export const CONTACT_INBOX = 'info@borisbags.com'

export function buildContactMailtoUrl({ name, email, website, message }) {
  const subject = `Website inquiry from ${name}`
  const body = [
    `Name: ${name}`,
    `Email: ${email}`,
    `Website: ${website}`,
    '',
    'Message:',
    message
  ].join('\n')

  const params = new URLSearchParams()
  params.set('subject', subject)
  params.set('body', body)

  return `mailto:${CONTACT_INBOX}?${params.toString()}`
}

export function openContactMailto(values) {
  window.location.href = buildContactMailtoUrl(values)
}
